import type { BaseTranslations } from "Infrastructure/Translation/Types/base";
import type { TOptions } from "i18next";
import type { ObjPathProxy } from "ts-object-path";

export const createSelectOptions = <T extends Record<string, unknown>>(
	enumObject: T,
	t?: (
		resourcePath: ObjPathProxy<unknown, string>,
		options?: TOptions,
	) => string,
	translationResource?: ObjPathProxy<BaseTranslations, Record<string, string>>,
): { label: string; value: T[keyof T] }[] =>
	Object.entries(enumObject).map(([key, value]) => ({
		label: translationResource && t ? t(translationResource[key]) : key,
		value: value as T[keyof T],
	}));
